import type { MessageType } from "@expert/shared-types";

import type { ExpertAssistMetadata } from "../../shared-types";

import { GuideRecommendationHeader } from "./custom-messages/GuideRecommendation";
import { SessionSummaryHeader } from "./custom-messages/SessionSummary";

export function MessageBubbleHeader({
    isLastProactiveMessage,
    type,
    metadata,
}: {
    isLastProactiveMessage: boolean;
    type: MessageType;
    metadata?: ExpertAssistMetadata;
}) {
    const { sessionSummary, guideRecommendation } = metadata || {};
    if (type === "SessionSummary" && sessionSummary) {
        return <SessionSummaryHeader metadata={sessionSummary} isLastProactiveMessage={isLastProactiveMessage} />;
    }

    if (type === "GuideRecommendation" && guideRecommendation) {
        return <GuideRecommendationHeader guideTitle={guideRecommendation} />;
    }
}
